import { netSheetAdditionalItems } from "../../../Common/commondata/commonData";

// export const addNewLoanComponent = ({ event, loanKey, loanValue, source }) => {
//   let valueObj = {};
//   const preEquityGroupTable = document.getElementById("preEquityGroupTable");
//   if (preEquityGroupTable) {
//     if (source === "setInitialValues") {
//     } else {
//       const currentRowCount = preEquityGroupTable.getElementsByTagName("tr").length;
//       const newLoanNumber = currentRowCount + 1;
//       valueObj[`Loan${newLoanNumber}`] = "";
//       preEquityGroupTable.innerHTML += `
//                 <tr class="priceLabel">
//                     <td style="width: 75%;">
//                         Loan${newLoanNumber}:
//                     </td>
//                     <td>
//                         <span class="priceTd tb">
//                             $<span class="grow-with-input"><input type="text"
//                                     class="grow currency inputBoxOutlineBorder" name="Loan${newLoanNumber}" size="8" data-preEquityGroup /></span>
//                         </span>
//                     </td>
//                 </tr>
//             `;
//     }
//   }
//   return valueObj;
// };

export const addNewLoanComponent = ({ event, loanKey, loanValue, source }) => {
  let valueObj = {};
  const preEquityGroupTable = document.getElementById("preEquityGroupTable");

  if (!preEquityGroupTable) return valueObj;

  if (source === "setInitialValues") {
    // return valueObj;
  }

  // Step 1: Collect all existing LoanX input names
  const existingInputs = document.querySelectorAll('[name^="Loan"]');
  const usedIndexes = new Set();

  existingInputs.forEach((input) => {
    const match = input?.name?.match(/^Loan(\d+)$/);
    if (match) usedIndexes.add(Number(match[1]));
  });

  // Step 2: Find the next unused Loan index
  let index = 1;
  while (usedIndexes.has(index)) {
    index++;
  }

  const newLoanKey = `Loan${index}`;
  valueObj[newLoanKey] = "";

  // Step 3: Append the new row
  preEquityGroupTable.innerHTML += `
    <tr class="priceLabel">
      <td style="width: 75%;">
        ${newLoanKey}:
      </td>
      <td>
        <span class="priceTd tb">
          $<span class="grow-with-input">
            <input type="text" class="grow currency inputBoxOutlineBorder" name="${newLoanKey}" size="8" data-preEquityGroup />
          </span>
        </span>
        <span>
          <i title="Remove Loan" class="bi bi-trash no-print clickable" style="color: #1488f4;" data-remove-item='${JSON.stringify({ loanKey: newLoanKey, source: "LOAN_ITEM" })}'></i>
        </span>
      </td>
    </tr>
  `;

  return valueObj;
};

export const addNewItem = ({ selectedItems, selectedItemsAndValuesContainer, source }) => {
  let valueObj = {};
  const postEquityGroupTable = document.getElementById("postEquityGroupTable");
  if (source === "setInitialValues" && selectedItemsAndValuesContainer?.length && postEquityGroupTable) {
  } else if (selectedItems?.length && postEquityGroupTable) {
    const newRows = selectedItems
      .map((item, index) => {
        // valueObj[`${item?.name}InPercentage`] = "";
        valueObj[item?.name] = "";
        return `
                <tr class="priceLabel" key="${item?.name}">
                    <td style="width: 75%;">
                        <div class="postEquityItemsFlex">
                            <span>${item?.label}</span>
                        </div>
                    </td>
                    <td>
                        <span class="priceTd tb">
                            $<span class="grow-with-input">
                                <input type="text" class="grow currency inputBoxOutlineBorder" name="${item?.name}" size="8" />
                            </span>
                        </span>
                    </td>
                </tr>
            `;
      })
      .join("");
    postEquityGroupTable.innerHTML += newRows;

    return valueObj;
  }
};

// export const addCustomBlankInputItem = ({ customFieldCount, source, blankItemLabelKeys, blankItemFeeAmtKeys }) => {
//   let valueObj = {};
//   const postEquityGroupTable2 = document.getElementById("postEquityGroupTable2");
//   if (source === "setInitialValues" && customFieldCount && postEquityGroupTable2) {
//   } else if (customFieldCount && postEquityGroupTable2) {
//     const currentRowCount = postEquityGroupTable2.getElementsByTagName("tr").length;
//     for (let i = 1; i <= customFieldCount; i++) {
//       const newRowNo = currentRowCount + i;
//       valueObj[`AdditionalFee${newRowNo}`] = "";
//       valueObj[`AdditionalFeeAmt${newRowNo}`] = "";
//       // valueObj[`AdditionalFee${newRowNo}InPercentage`] = '';
//       const newBlankRows = `
//                 <tr class="priceLabel">
//                     <td style="width: 75%;">
//                         <div class="postEquityItemsFlex">
//                             <span class="grow-with-input">
//                                 <input type="text" class="grow inputBoxOutlineBorder" name="AdditionalFee${newRowNo}" data-postEquityGroupLabel size="40" />
//                             </span>
//                         </div>
//                     </td>
//                     <td>
//                         <span class="priceTd tb">
//                             $<span class="grow-with-input">
//                                 <input type="text" class="grow currency inputBoxOutlineBorder" name="AdditionalFeeAmt${newRowNo}" data-postEquityGroupInput size="8" />
//                             </span>
//                         </span>
//                     </td>
//                 </tr>
//             `;
//       postEquityGroupTable2.innerHTML += newBlankRows;
//     }
//   }
//   return valueObj;
// };

export const addCustomBlankInputItem = ({ customFieldCount }) => {
  let valueObj = {};
  const postEquityGroupTable2 = document.getElementById("postEquityGroupTable2");

  if (customFieldCount && postEquityGroupTable2) {
    // Get all existing keys
    const allInputs = document.querySelectorAll('[name^="AdditionalFee"], [name^="AdditionalFeeAmt"]');
    const usedIndexes = new Set();

    allInputs.forEach((input) => {
      const match = input.name.match(/\d+$/);
      if (match) usedIndexes.add(Number(match[0]));
    });

    let index = 1;
    let added = 0;
    while (added < customFieldCount) {
      if (!usedIndexes.has(index)) {
        const labelKey = `AdditionalFee${index}`;
        const amtKey = `AdditionalFeeAmt${index}`;
        valueObj[labelKey] = "";
        valueObj[amtKey] = "";

        const newBlankRows = `
          <tr class="priceLabel">
            <td style="width: 75%;">
              <div class="postEquityItemsFlex">
                <span class="grow-with-input">
                  <input type="text" class="grow inputBoxOutlineBorder" name="${labelKey}" data-postEquityGroupLabel size="40" />
                </span>
              </div>
            </td>
            <td>
              <span class="priceTd tb">
                $<span class="grow-with-input">
                  <input type="text" class="grow currency inputBoxOutlineBorder" name="${amtKey}" data-postEquityGroupInput size="8" />
                </span>
              </span>
            </td>
          </tr>
        `;

        postEquityGroupTable2.innerHTML += newBlankRows;
        added++;
      }
      index++;
    }
  }

  return valueObj;
};


const checkForLoans = (td={}) => {
  const loanKeys = Object.keys(td).filter((key) => /^Loan\d+$/.test(key) && key !== "Loan1");
  const preEquityGroupTable = document.getElementById("preEquityGroupTable");
  if (preEquityGroupTable) {
    // Removing the existing dynamic rows (except for Loan1)
    const existingRows = Array.from(preEquityGroupTable.querySelectorAll("tr.priceLabel"));
    existingRows.forEach((row, index) => {
      if (index > 0) row.remove(); // Keeping the first row (Loan1)
    });
    // Sorting loan keys numerically
    loanKeys.sort((a, b) => {
      return parseInt(a.replace("Loan", ""), 10) - parseInt(b.replace("Loan", ""), 10);
    });

    loanKeys?.forEach((loanKey) => {
      const row = document.createElement("tr");
      row.classList.add("priceLabel");
      row.innerHTML = `
                  <td style="width: 75%;">${loanKey}:</td>
                  <td>
                      <span class="priceTd tb">
                          $<span class="grow-with-input"><input type="text"
                              class="grow currency inputBoxOutlineBorder" name="${loanKey}" size="8" data-preEquityGroup /></span>
                      </span>
                      <span><i title="Remove Loan" class="bi bi-trash no-print clickable" style="color: #1488f4;" data-remove-item='${JSON.stringify({loanKey, source: "LOAN_ITEM"})}'></i></span>
                  </td>
              `;
      preEquityGroupTable.appendChild(row);
    });
  }
};

const checkForAdditionalFees = (td={}) => {
  let selectedItemsAndValuesContainer = [];
  netSheetAdditionalItems?.forEach((item) => {
    if (td.hasOwnProperty(item.name)) {
      selectedItemsAndValuesContainer.push({
        item,
        value: td[item.name] || "",
        // percentage: td[`${item.name}InPercentage`] || "",
      });
    }
  });
  if (selectedItemsAndValuesContainer.length) {
    const postEquityGroupTable = document.getElementById("postEquityGroupTable");
    if (postEquityGroupTable) {
      postEquityGroupTable.innerHTML = ""; // Clearing existing rows
      selectedItemsAndValuesContainer.forEach(({ item: { name, label }, value }) => {
        const row = document.createElement("tr");
        row.classList.add("priceLabel");
        row.innerHTML = `
                    <td style="width: 75%;">
                        <div class="postEquityItemsFlex">
                            <span>${label}</span>
                        </div>
                    </td>
                    <td>
                        <span class="priceTd tb">
                            $<span class="grow-with-input">
                                <input type="text" class="grow currency inputBoxOutlineBorder" name="${name}" size="8" value="${value}" />
                            </span>
                        </span>
                        <span><i title="Remove Item" class="bi bi-trash no-print clickable" style="color: #1488f4;" data-remove-item='${JSON.stringify({name, label, value, source: "ADDITIONAL_ITEM"})}'></i></span>
                    </td>
                `;
        postEquityGroupTable.appendChild(row);
      });
    }
  }
};

// const checkForBlankItems = (td = {}) => {
//   const blankItemLabelKeys = Object.keys(td)?.filter((key) => /^AdditionalFee\d+$/.test(key));
//   const blankItemFeeAmtKeys = Object.keys(td)?.filter((key) => /^AdditionalFeeAmt\d+$/.test(key));
//   const maxRows = Math.max(blankItemLabelKeys?.length, blankItemFeeAmtKeys?.length);

//   const postEquityGroupTable2 = document.getElementById("postEquityGroupTable2");
//   if (postEquityGroupTable2) {
//     postEquityGroupTable2.innerHTML = "";
//     for (let i = 0; i < maxRows; i++) {
//       const labelKey = blankItemLabelKeys[i] || "";
//       const amtKey = blankItemFeeAmtKeys[i] || "";
//       const row = document.createElement("tr");
//       row.classList.add("priceLabel");
//       row.innerHTML = `
//                   <td style="width: 75%;">
//                       <div class="postEquityItemsFlex">
//                           <span class="grow-with-input">
//                               <input type="text" class="grow inputBoxOutlineBorder" name="${labelKey}" size="40" data-postEquityGroupLabel />
//                           </span>
//                       </div>
//                   </td>
//                   <td>
//                       <span class="priceTd tb">
//                           $<span class="grow-with-input">
//                               <input type="text" class="grow currency inputBoxOutlineBorder" name="${amtKey}" size="8" data-postEquityGroupInput />
//                           </span>
//                       </span>
//                       <span><i title="Remove Item" class="bi bi-trash no-print clickable" style="color: #1488f4;" data-remove-item='${JSON.stringify({labelKey, amtKey, source: "CUSTOM_ITEM"})}'></i></span>
//                   </td>
//               `;
//       postEquityGroupTable2.appendChild(row);
//     }
//   }
// };

const checkForBlankItems = (td = {}) => {
  const postEquityGroupTable2 = document.getElementById("postEquityGroupTable2");
  if (!postEquityGroupTable2) return;

  postEquityGroupTable2.innerHTML = "";

  // Extract all fee indices (e.g., 1, 2, 3...) from both label and amount keys
  const feeIndices = new Set();

  for (const key of Object.keys(td)) {
    const match = key.match(/^AdditionalFee(?:Amt)?(\d+)$/);
    if (match) {
      feeIndices.add(match[1]); // add the number as string
    }
  }
  // Sort for predictable order
  const sortedIndices = Array.from(feeIndices).sort((a, b) => Number(a) - Number(b));

  for (const index of sortedIndices) {
    const labelKey = `AdditionalFee${index}`;
    const amtKey = `AdditionalFeeAmt${index}`;

    const row = document.createElement("tr");
    row.classList.add("priceLabel");
    row.innerHTML = `
      <td style="width: 75%;">
        <div class="postEquityItemsFlex">
          <span class="grow-with-input">
            <input type="text" class="grow inputBoxOutlineBorder" name="${labelKey}" size="40" value="${td[labelKey] || ""}" data-postEquityGroupLabel />
          </span>
        </div>
      </td>
      <td>
        <span class="priceTd tb">
          $<span class="grow-with-input">
            <input type="text" class="grow currency inputBoxOutlineBorder" name="${amtKey}" size="8" value="${td[amtKey] || ""}" data-postEquityGroupInput />
          </span>
        </span>
        <span>
          <i 
            title="Remove Item" 
            class="bi bi-trash no-print clickable" 
            style="color: #1488f4;" 
            data-remove-item='${JSON.stringify({ labelKey, amtKey, source: "CUSTOM_ITEM" })}'
          ></i>
        </span>
      </td>
    `;

    postEquityGroupTable2.appendChild(row);
  }
};

export const checkDynamicFieldsOfNetSheet = (td) => {
  checkForLoans(td);
  checkForAdditionalFees(td);
  checkForBlankItems(td);
};
